"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gateway client instance response from a get status request.
 */
var GetStatusResponse = /** @class */ (function () {
    /**
     * Create a new GetStatusResponse instance
     *
     * @param type response type
     * @param items the items
     */
    function GetStatusResponse(type, items) {
        this.type = type;
        this.items = items;
    }
    return GetStatusResponse;
}());
exports.GetStatusResponse = GetStatusResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/get-status-response.js
// module id = 1950
// module chunks = 1